
//******************Exchange Rate Server Calls******************;

import { UndoDeleteCouponActions } from './UndoDeleteCouponConstants';
import store from '../../../Store/store'
import {  ROOT_URL,getCookie } from '../../../Config/Config';
import {failure_messages} from 'Messages'

export const UndoDeleteCouponServer = {
  //  getUndoDeleteCoupon:getUndoDeleteCoupon,
  handleUndoDeleteCoupon: handleUndoDeleteCoupon
  // updateUndoDeleteCoupon: updateUndoDeleteCoupon
};

//******************Insert UndoDeleteCoupons******************;

function handleUndoDeleteCoupon(data) {
  //alert('save')
 
  const request = fetch(ROOT_URL + '/api/coupon/HandleCouponBatchUpdate', {
    method: 'Post',
    mode: 'cors',
    headers: { 
      'authorization':getCookie("admin_token_partner"),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then((response) => {
    // alert(JSON.stringify(response))
    response.json().then(responseJson => {

      if (responseJson.status == "200") {
        console.log(responseJson)
        // alert(JSON.stringify(data.batch_status))
        store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.SUCCESS, payload: data, message:responseJson.message });
      
      } else {

        store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED,  payload: data, error:responseJson.error});

      }
    }).catch((error) => {
        console.log(error)
      store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED,payload: data, error:failure_messages.unExpectedError });
    })
  }).catch((error) => {
      console.log(error)
    store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED, payload: data, error:failure_messages.unExpectedError });
  })
  return { type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.LOADING }

};

//******************Get UndoDeleteCoupons******************;


//******************Update UndoDeleteCoupon******************;


// function getUndoDeleteCoupon(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.UndoDeleteCoupon.length>0)
//              store.dispatch({type:UndoDeleteCouponActions.UndoDeleteCoupon_Get.SUCCESS,payload:response.UndoDeleteCoupon});
//              else
//              store.dispatch({type:UndoDeleteCouponActions.UndoDeleteCoupon_Post.NEW});

//              return ;
//              }else
//              {
//                store.dispatch({type:UndoDeleteCouponActions.UndoDeleteCoupon_Get.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:UndoDeleteCouponActions.UndoDeleteCoupon_Get.FAILED});
//           })
//        return {type:UndoDeleteCouponActions.UndoDeleteCoupon_Post.LOADING}

//     };

// function updateUndoDeleteCoupon(data, token) {
//   const request = fetch(RETAILER_API_URL + '/api/business/updateApplicationBusiness', {

//     method: 'Post',
//     mode: 'cors',
//     headers: { 'Content-Type': 'application/json', 'x-access-token': token },
//     body: JSON.stringify(data)
//   }).then((response) => {
//     response.json().then(response => {
//       if (response.status == "200") {

//         store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.SUCCESS, payload: data.data, message:response.message });
//         return;
//       } else {
//         // alert("test")
//         store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED,  payload: data.data, error:response.error});

//       }
//     }).catch((error) => {
//         console.warn(error)
//       store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED,payload: data.data, error:failure_messages.unExpectedError });
//     })
//   }).catch((error) => {
//       console.log(error)
//     store.dispatch({ type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.FAILED, payload: data.data, error:failure_messages.unExpectedError });
//   })
//   return { type: UndoDeleteCouponActions.UndoDeleteCoupon_Post.LOADING }

// };
